/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Shipper } from '../../models/shipper';

export interface MgmtShipperControllerGetLegacyShippers$Params {
}

export function mgmtShipperControllerGetLegacyShippers(http: HttpClient, rootUrl: string, params?: MgmtShipperControllerGetLegacyShippers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Shipper>>> {
  const rb = new RequestBuilder(rootUrl, mgmtShipperControllerGetLegacyShippers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Shipper>>;
    })
  );
}

mgmtShipperControllerGetLegacyShippers.PATH = '/api/mgmt/shippers/legacy-shippers';
